import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import { logger } from 'redux-logger';

import login from '../../features/login/presentation/redux/reducers/login-reducers';

import token from './reducers/token-reducers';
import loading from './reducers/loading-reducers';
import me from '../../features/me/presentation/redux/reducers/me-reducer';

import clients from '../../features/clients/presentation/redux/reducers/clients-reducers';
import upload from '../../features/clients/presentation/redux/reducers/upload-reducer';
import client from '../../features/clients/presentation/redux/reducers/client-reducer';
import apikey from '../../features/clients/presentation/redux/reducers/apikey-reducer';

import user from '../../features/users/presentation/redux/reducers/user-reducer';
import users from '../../features/users/presentation/redux/reducers/users-reducer';

import contracts from '../../features/contracts/presentation/redux/reducers/contracts-reducer';
import contract from '../../features/contracts/presentation/redux/reducers/contract-reducer';

import orders from '../../features/orders/presentation/redux/reducers/orders-reducer';
import partners from '../../features/three-pl-partners/presentation/redux/reducers/partners-reducer';
import partner from '../../features/three-pl-partners/presentation/redux/reducers/partner-reducer';
// Setup Redux store with Thunks
const reducers = combineReducers({
  me,
  loading,
  login,
  token,
  clients,
  upload,
  client,
  apikey,
  contracts,
  contract,
  user,
  users,
  orders,
  partners,
  partner
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_APPLICATION_STATE') {
    state = undefined;
  }

  return reducers(state, action);
};
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
export type AppState = ReturnType<typeof rootReducer>;
